import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";
import { observer } from "mobx-react-lite";
import type { FunctionComponent } from "react";
import React from "react";
import { Col } from "react-bootstrap";
import FormGroup from "controls/formGroup";
import FormLabel from "controls/formLabel";
import { translateGeneral } from "utils/localizations";
import type PayGateTransactionsViewModel from "viewModels/finance/payGateTransactions/payGateTransactionsViewModel";
import FilterView from "../../common/filter";

interface PayGateTransactionFiltersProps {
  vm: PayGateTransactionsViewModel;
}

const PayGateTransactionFilters: FunctionComponent<PayGateTransactionFiltersProps> = ({ vm }) => (
  <FilterView vm={vm}>
    <div className="row">
      <FormGroup as={Col} md={6} lg={4} xl={3} target={vm.filter} property="sinceDate">
        <FormLabel>{vm.translate("filterFrom")}</FormLabel>
        <AdvancedSelect items={vm.startOfMonthOptions} placeholder={translateGeneral("select")} />
      </FormGroup>
      <FormGroup as={Col} md={6} lg={4} xl={3} target={vm.filter} property="untilDate">
        <FormLabel>{vm.translate("filterTo")}</FormLabel>
        <AdvancedSelect items={vm.endOfMonthOptions} placeholder={translateGeneral("select")} />
      </FormGroup>
    </div>
  </FilterView>
);

export default observer(PayGateTransactionFilters);
